import { CSSProperties } from "react";
import {
  NOTE_PREVIEW_GROUP_HEADING_FONT_SIZE_PX,
  NOTE_PREVIEW_PRIMARY_COLOR,
} from "../note-preview-constant";

export interface ReportGroupHeadingProps {
  label: string;
  style?: CSSProperties;
}

/** Uppercase heading above a run of groups, as the form prints "FALL RISK ASSESSMENT". */
const ReportGroupHeading = ({ label, style }: ReportGroupHeadingProps) => (
  <div
    style={{
      margin: "8px 0 4px",
      fontSize: NOTE_PREVIEW_GROUP_HEADING_FONT_SIZE_PX,
      fontWeight: 700,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: NOTE_PREVIEW_PRIMARY_COLOR,
      breakAfter: "avoid",
      ...style,
    }}
  >
    {label}
  </div>
);

export default ReportGroupHeading;
